import type { FaireProductEntity } from "../../entity_types/product";

export const p_7w3ks5pj22: FaireProductEntity = {
  token: "p_7w3ks5pj22",
  type: "product",
  name: "Peanut Butter Fudge",
  brandToken: "b_hxncymjum6",
  brandName: "Phenomenal Fudge",
  imageUrl:
    "https://cdn.faire.com/fastly/d717ba529e78ad717cc153eb2cba4b77c6faa8e6b8f2762a0b4bed847fc0c405.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9032d2ae4ff4dec141b46eba1c4143a6b9a69e07455582ad5d90534e14391e94.jpeg",
  ],
  priceDollars: 7.58,
  description:
    "Here is the true taste of Peanut Butter Fudge because we use fesh, real smooth peanut butter. Although it sounds simple enough to make it is in fact, one of the most difficult for us to make. The temperature and humidity of our fudge kitchen have to be just right to get the peanut butter and the vanilla base to evenly mix together. FREE SHIPPING on all orders over $55. \n\nBe aware, however, that very hot weather (above 85 degrees) can release the peanut butter oils causing a harmless but not-so nice looking white film on the top. Regardless, it still tastes phenomenal. \n\nPeanut Butter Fudge in a 1/2 pound resealable tub.\n",
  tags: [],
  msrpDollars: 15.17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:51.303Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
